module.exports = __webpack_public_path__ + "img/h_s2e2_gallery_1.ffbffb3a.png";